import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section id="contacto" className="py-24 bg-brand-black text-white relative overflow-hidden" data-id="element-66">
      {/* Background Glows */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-cyan/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-67" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-brand-cyan/10 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/3 pointer-events-none" data-id="element-68" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-69">
        <div className="max-w-4xl mx-auto text-center" data-id="element-70">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-71">
            ¿Listo para crecer más rápido?
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-72">
            Descubre cómo podemos ayudarte a atraer más clientes y automatizar
            tu negocio.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-73">
            <a href="https://wa.me/573016232980" target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 bg-brand-cyan text-brand-black px-10 py-5 rounded-full font-bold text-lg hover:bg-white transition-all duration-300 shadow-[0_0_30px_rgba(0,200,215,0.3)] hover:shadow-[0_0_40px_rgba(255,255,255,0.4)] group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-cyan focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black" data-id="element-74">
              Agendar Diagnóstico Gratuito
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-75" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}